/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { Component, OnInit, HostListener, Inject } from '@angular/core';
import { DOCUMENT, ViewportScroller } from '@angular/common';
import { DeviceCheckService } from 'src/app/viewbid/shared/services/device-check.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-back-to-top',
    templateUrl: './back-to-top.component.html',
    styleUrls: ['./back-to-top.component.scss'],
})
export class BackToTopComponent {
    showBackToTopBtn = false;
    private destroy$ = new Subject<void>();
    public isMobile: boolean = false;

    constructor(
        @Inject(DOCUMENT) private document: any,
        private deviceCheckService: DeviceCheckService,
    ) {
        this.deviceCheckService.isMobile$
            .pipe(takeUntil(this.destroy$))
            .subscribe((isMobile: boolean) => {
                this.isMobile = isMobile;
                this.showBackToTopBtn = isMobile;
            });
    }

    @HostListener('window:wheel', []) onWindowScroll() {
        const scrollPosition: number =
            window.pageYOffset ||
            this.document.documentElement.scrollTop ||
            this.document.body.scrollTop ||
            0;
        if (!this.isMobile) {
            this.showBackToTopBtn = scrollPosition > 50;
        }
    }

    scrollToTop() {
        this.document.body.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
        window.scrollTo({ top: 0, behavior: 'smooth' });
        if (!this.isMobile) {
            this.showBackToTopBtn = false;
        }
    }
}
